import { group } from 'console'
import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface MasterConcepts {
  name: string
  code: string
  countryId: string
  conceptFormatId: string
  conceptCategoryId: string
  conceptTypeId: string
  groupMemberships: string[]
  appliesTo: any[]
  isStandard: boolean
}

export async function getListMasterConceptsGroups(): Promise<any> {
  const where = ['country_id = :countryId']

  // result
  const response: any = await getData({
    tables: ['pg_master_concept_groups'],
    fields: ['id', 'code as name'],
    where,
    modifier: ['order by code desc'],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 20 }
    }
  })
  console.log('response grupo', response)
  return response[0].results
}

export async function getMasterConcepts(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = '',
  groups: string[] = []
): Promise<any> {
  console.log('groups', groups)

  // where's
  const where = [
    'master_concepts.country_id = :countryId',
    'master_concepts.concept_type_id = concept_types.id',
    'master_concepts.concept_format_id = concept_formats.id',
    'master_concepts.concept_category_id=concept_categories.id'
  ]

  if (search) {
    where.push(
      `CONCAT(master_concepts.name,master_concepts.code) ILIKE '%${search}%'`
    )
  }

  if (groups.length > 0) {
    where.push(
      `master_concepts.id IN (SELECT master_concept_id FROM master_concept_group_memberships WHERE group_id IN (${groups
        .map(group => `'${group}'`)
        .join(',')}))`
    )
  }

  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          'GROUP BY master_concepts.id, concept_types.name, concept_formats.name, concept_categories.name',
          `ORDER BY (CASE WHEN master_concepts.code ~ '^[0-9]+$' THEN CAST(master_concepts.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, master_concepts.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        'GROUP BY master_concepts.id, concept_types.name, concept_formats.name, concept_categories.name',
        "ORDER BY (CASE WHEN master_concepts.code ~ '^[0-9]+$' THEN CAST(master_concepts.code AS numeric) ELSE NULL END), master_concepts.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_master_concepts'],
    fields: [
      'master_concepts.id',
      'master_concepts.code',
      'master_concepts.name',
      'master_concepts.is_inactive',
      'concept_formats.name as format',
      'concept_categories.name as category',
      'concept_types.name as type',
      `COALESCE(ARRAY_AGG(DISTINCT master_concept_groups.code) FILTER (WHERE master_concept_groups.code IS NOT NULL), '{}') as groups`,
      'master_concepts.updated_at'
    ],
    join: [
      'INNER JOIN concept_types ON master_concepts.concept_type_id = concept_types.id',
      'INNER JOIN concept_formats ON master_concepts.concept_format_id = concept_formats.id',
      'INNER JOIN concept_categories ON master_concepts.concept_category_id = concept_categories.id',
      'LEFT JOIN master_concept_group_memberships ON master_concept_group_memberships.master_concept_id = master_concepts.id',
      'LEFT JOIN master_concept_groups ON master_concept_groups.id = master_concept_group_memberships.group_id'
    ],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response
}

export async function getMasterConcept(id: string): Promise<MasterConcepts> {
  const data = await getData<any>({
    tables: ['pg_master_concepts'],
    fields: [
      'master_concepts.id',
      'master_concepts.code',
      'master_concepts.name',
      'master_concepts.country_id as countryId',
      'master_concepts.concept_category_id as conceptCategoryId',
      'master_concepts.concept_type_id as conceptTypeId',
      'master_concepts.concept_format_id as conceptFormatId',
      'master_concepts.is_inactive',
      'master_concepts.applies_to as appliesTo',
      'master_concepts.is_standard as isStandard',
      'master_concepts.custom_fields as custom',
      "COALESCE(ARRAY_AGG(master_concept_group_memberships.group_id) FILTER (WHERE master_concept_group_memberships.id IS NOT NULL), '{}')  as groupMemberships"
    ],
    join: [
      'LEFT JOIN master_concept_group_memberships ON master_concept_group_memberships.master_concept_id = master_concepts.id'
    ],
    where: [`master_concepts.id = '${id}'`],
    modifier: [
      'GROUP BY master_concepts.id,master_concepts.code, master_concepts.name,"countryId","conceptCategoryId","conceptTypeId","conceptFormatId",master_concepts.is_inactive,"appliesTo","isStandard",custom'
    ],
    options: {
      outputFormat: 'json',
      pagination: {
        offset: 0,
        limit: 10
      }
    }
  })
  return data[0].results[0]
}

export async function createMasterConcept(
  data: MasterConcepts
): Promise<boolean> {
  const response: any = await http.post('concept/master-concepts', {
    name: data.name,
    code: data.code,
    countryId: data.countryId,
    conceptFormatId: data.conceptFormatId,
    conceptCategoryId: data.conceptCategoryId,
    conceptTypeId: data.conceptTypeId,
    groups: data.groupMemberships,
    appliesTo: data.appliesTo,
    isStandard: data.isStandard,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateMasterConcept(
  data: MasterConcepts,
  id: string
): Promise<boolean> {
  const response: any = await http.put('concept/master-concepts/' + id, {
    name: data.name,
    code: data.code,
    conceptFormatId: data.conceptFormatId,
    conceptCategoryId: data.conceptCategoryId,
    conceptTypeId: data.conceptTypeId,
    groups: data.groupMemberships,
    appliesTo: data.appliesTo,
    isStandard: data.isStandard,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateStateConceptsMaster(
  id: string,
  state: boolean
): Promise<boolean> {
  const response: any = await http.put(`concept/master-concepts/${id}/enable`, {
    enable: state
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteMasterConcept(id: string): Promise<boolean> {
  const response: any = await http.delete('concept/master-concepts/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
